import { render, staticRenderFns } from "./Weight.vue?vue&type=template&id=17f7f940&scoped=true"
import script from "./Weight.vue?vue&type=script&lang=js"
export * from "./Weight.vue?vue&type=script&lang=js"
import style0 from "./Weight.vue?vue&type=style&index=0&id=17f7f940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f7f940",
  null
  
)

export default component.exports